module.exports = __webpack_public_path__ + "static/media/companyselectedIcon.91b0da75.svg";